import { configureStore } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

// Import des slices
import authentification from './authentificationSlice';
import tenant from './tenantSlice';
import lease from './leaseSlice';
import local from './localSlice';
import room from './roomSlice';
import charge from './chargeSlice';
import owner from './ownerSlice';
import rent from './rentSlice';
import courrier from './courrierSlice';
import document from './documentSlice';
import todo from './todoSlice';
import rappel from './rappelSlice';
import artisan from './artisanSlice';
import payment from './paymentsSlice';
import banque from './banqueSlice';
import job from './jobSlice';
import jobcommande from './jobcommandeSlice';
import jobtodo from './jobtodoSlice';
import roomstate from './roomstateSlice';
import counter from './counterSlice';
import edlElement from './edlElementSlice';
import localAccessory from './localAccessorySlice';
import edlPicture from './edlPictureSlice';
import pictureroom from './pictureroomSlice';
import bailTemplate from './bailTemplateSlice';
import message from './messageSlice';
import bailComplementaire from './bailComplementaireSlice';
import leaseKey from './leaseKeySlice';
import scheduledSend from './scheduledSendSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['authentification'],
};

const rootReducer = combineReducers({
  authentification, tenant, lease, local, room, charge, owner, rent,
  courrier, document, todo, rappel, artisan, job, jobcommande,
  jobtodo, payment, banque, roomstate, counter,
  edlElement, localAccessory, edlPicture, pictureroom, bailTemplate, message, leaseKey, scheduledSend, bailComplementaire,
});

// Intercepte RESET_STORE pour réinitialiser TOUS les slices (changement d'utilisateur, token expiré)
const rootReducerWithReset = (
  state: ReturnType<typeof rootReducer> | undefined,
  action: any
) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducerWithReset);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

if (process.env.NODE_ENV === 'development') {
  store.subscribe(() => {
    console.log('🏪 Store State:', store.getState());
  });
}

export default store;